var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',{staticClass:"white-text d-flex align-center justify-center",staticStyle:{"height":"100%"}},[_vm._v(" Version 0.1.0 ")])])}]

export { render, staticRenderFns }